import * as React from "react";
import { Formik, Form } from "formik";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import ArchiveSizeEstimate from "data-lake/components/ArchiveSizeEstimate";
import { Modal, Input } from "components/bootstrap";
import { FormikInput, ModalSubmit } from "components/common";
import useUserDateTime from "hooks/useUserDateTime";
import { getRangeValidationErrors } from "data-lake/components/DataLakeActionModals/utils";
import TimeRangeField from "data-lake/components/DataLakeActionModals/TimeRangeField";
const StyledModal = styled(Modal)`
  z-index: 1070;
`;
const FullDelete = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.spacings.lg};
    margin-top: ${theme.spacings.lg};
  `
);
const getDefaultValues = (formatTime, timeRange) => {
  const from = (timeRange == null ? void 0 : timeRange.from) || (/* @__PURE__ */ new Date()).setMinutes(0, 0);
  const to = (timeRange == null ? void 0 : timeRange.to) || (/* @__PURE__ */ new Date()).setMinutes(0, 0);
  return {
    nextTimeRange: {
      type: "absolute",
      from: formatTime(from),
      to: formatTime(to)
    }
  };
};
const DataLakeDeleteActionForm = ({
  defaultTimeRange = null,
  show,
  onSubmit,
  onHide,
  children,
  dataLakeId,
  streamIds
}) => {
  const { t } = useTranslation("enterprise_data_lake");
  const { formatTime } = useUserDateTime();
  const submitButtonText = t("delete_form.submit_button");
  const validate = (values) => {
    const {
      nextTimeRange: { to, from },
      fullDelete
    } = values;
    const errors = !fullDelete ? getRangeValidationErrors(from, to) : {};
    return errors;
  };
  const handleSubmit = ({
    nextTimeRange: { from, to },
    fullDelete,
    wipeRestores,
    streamIds: streamIdList
  }) => {
    onSubmit({
      from,
      to,
      full_delete: fullDelete,
      wipe_restores: wipeRestores,
      data_lake_id: dataLakeId,
      stream_ids: streamIdList
    });
  };
  return /* @__PURE__ */ React.createElement(StyledModal, { onHide: () => onHide(), show }, /* @__PURE__ */ React.createElement(
    Formik,
    {
      initialValues: {
        ...getDefaultValues(formatTime, defaultTimeRange)
      },
      onSubmit: handleSubmit,
      validate,
      validateOnMount: true
    },
    ({ isSubmitting, isValidating, isValid, values: { fullDelete, nextTimeRange } }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, t("delete_form.title"))), /* @__PURE__ */ React.createElement(Modal.Body, null, children, /* @__PURE__ */ React.createElement(FullDelete, null, /* @__PURE__ */ React.createElement(Input, { id: "fullDelete", label: t("delete_form.full_delete_label") }, /* @__PURE__ */ React.createElement(
      FormikInput,
      {
        label: t("delete_form.full_delete_checkbox"),
        name: "fullDelete",
        id: "fullDelete",
        type: "checkbox"
      }
    )), fullDelete && /* @__PURE__ */ React.createElement(Input, { id: "wipe_restores", label: t("delete_form.wipe_retrievals_label") }, /* @__PURE__ */ React.createElement(
      FormikInput,
      {
        label: t("delete_form.wipe_retrievals_checkbox"),
        name: "wipeRestores",
        id: "wipeRestores",
        disabled: !fullDelete,
        type: "checkbox"
      }
    ))), !fullDelete && /* @__PURE__ */ React.createElement(TimeRangeField, { submitButtonText, hourOnly: true }), !fullDelete && isValid && /* @__PURE__ */ React.createElement(
      ArchiveSizeEstimate,
      {
        estimateParams: {
          streamIds,
          dataLakeId,
          from: nextTimeRange.from,
          to: nextTimeRange.to
        }
      }
    )), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
      ModalSubmit,
      {
        submitButtonText,
        submitLoadingText: t("action_form.submitting"),
        onCancel: () => onHide(),
        disabledSubmit: isValidating || !isValid,
        isSubmitting
      }
    )))
  ));
};
export default DataLakeDeleteActionForm;
